import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServices";
import ApproveOrRejectRequisitionModalAdmin from "../Requisition/ApproveOrRejectRequisitionModalAdmin";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import axios from "axios";


const DiseleSuperAdminApproval  = () => {
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [sort, setSort] = useState(40); // Number of items per page
  const activePag = useRef(0);
  const [test, setTest] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeUsers, setActiveUsers] = useState([]);
  const [activePage, setActivePag] = useState();
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState({})
  const [loading, setLoading] = useState(false);

  const [requisition, setRequisiton] = useState();
  const [selectedRequisition, setSelectedRequisiton] = useState();
  const [run, setRun] = useState(0);

  const location = useLocation();
  const [error, setError] = useState(null);

  // Extract token from URL
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");


  console.log(token)
  // useEffect(() => {
  //   if (selectedStore) {
  //     setLoading(true); // Start loader before making the request
  //     const status = "adminSubmit";
  //     RequestServies.getRequest(selectedStore, status)
  //       .then((res) => {
  //         console.log(res)
  //         setRequisiton(res?.data?.data);
  //         setSelectedRequisiton(res?.data?.data[0]._id);
  //         setLoading(false); // Stop loader once data is set

  //       })
  //       .catch((error) => {
  //         setLoading(false); // Stop loader on error
  //         console.log(error);
          

  //       });
  //   }
  // }, [selectedStore]);

  useEffect(() => {
    if (!token) {
      setError("Invalid or missing token.");
      setLoading(false);
      return;
  }
  
      setLoading(true); // Start loader before making the request
      const status = "pending";
      axios.get(`http://localhost:3001/api/v1/desile/adminapproved/desileitem`, {
        headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      console.log(res)
      setData(res?.data?.data?.data);
      //console.log(res?.data?.data)
      setLoading(false)
    })
    .catch((err) => {
      setLoading(false); // Stop loader on error
      console.log(error);
    });
        
  
  }, [ run]);

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
  };

  const handleRequsitionChange = (e) => {
    setSelectedRequisiton(e.target.value);
  };

  // Pagination setup
  useEffect(() => {
    if (data.length > 0) {
      setActivePag(0); // Reset pagination when data changes
    }
  }, [data]);
  
  const pagination = Math.ceil(data.length / sort);
  const onClick = (i) => {
    activePag.current = i;
    setTest(i);
  };

  const handleModel = (e, item) => {
    console.log(item)
    setSelectedItem(item)
    setGridInsideModal(true)
  }
  const handleApproval = (item, status) => {
    Swal.fire({
      title: `Are you sure you want to ${status} this request?`,
      text: `Requisition No: ${item?.requisitionNo}/Part No: ${item?.inventory?.masterItem?.partNo}`,
      icon: status === "approved" ? "success" : "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, proceed",
      cancelButtonText: "Cancel",
      input: status === "rejected" ? "textarea" : null, // Show textarea for remarks if rejecting
      inputPlaceholder: "Enter your remarks here...",
      inputValidator: (value) => {
        if (status === "rejected" && !value) {
          return "Remarks are required for rejection!";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if(status === "rejected"){
          var remark=result.value
         }else{
           remark='Approved by Admin'
         }
        RequestServies.updateDesileBySuperItem(item._id, {
          approveQty: item.qtyRequired,
          status,
        })
          .then(() => {
            Swal.fire({
              icon: "success",
              title: `Request ${status}`,
              text: `The request has been ${status}.`,
            });
            setRun((prev) => prev + 1);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "An error occurred while processing the request.",
            });
            console.error(error);
          });
      }
    });
  };


  return (
    <>
      {/* <ApproveOrRejectRequisitionModalAdmin
        show={gridInsideModal}
        item={selectedItem}
        handleClose={() => setGridInsideModal(false)}
        onSuccess={() => setRun(prev => prev + 1)}
      /> */}

      <div className="row">
      {loading ? ( // Show loader if data is loading
           <div className="loader-container">
           <div className="loader"></div>
           <p className="loading-text">Pending List Loading...</p>
         </div>
        ) : (
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    {/* <div className="col-xl-6 col-xxl-6">
                      <label>Select Store</label>
                      <select
                        className="form-select mb-xl-0 mb-3"
                        value={selectedStore}
                        onChange={handleStoreChange}
                      >
                        {stores.map((store) => (
                          <option key={store._id} value={store._id}>
                            {store.name}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    {/* <div className="col-xl-6 col-xxl-6">
                      <label>Select Requisition Number </label>
                      <select
                        className="form-select mb-xl-0 mb-3"
                        value={selectedRequisition}
                        onChange={handleRequsitionChange}
                      >
                        {requisition && requisition.length > 0 ? (
                          requisition.map((item) => (
                            <option key={item._id} value={item._id}>
                              {item.requisitionNo}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled selected>
                            No records found
                          </option>
                        )}
                      </select>

                    </div> */}
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary mt-1">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-list me-2" aria-hidden="true"></i>Pending
                Approval{" "}
                <span className="badge bg-orange ms-2">{data.length}</span>
              </div>
              <div className="tools">
                <Link
                  to="#"
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                        id="active-users-data"
                      >
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Requisition No</th>
                            <th>Part No</th>
                            <th>Description</th>
                            <th>AuthQty(ltr)</th>
                            <th>Eligible(ltr)</th>
                            <th>currentStock(ltr)</th>
                            <th>RequestedQty(ltr)</th>
                            <th>Request status</th>
                            {/* <th>Edit</th> */}
                            <th className="text-center">Action</th>
                            
                          </tr>
                        </thead>
                        <tbody>
                          {data.length > 0 ? (
                            data
                              .slice(
                                activePag.current * sort,
                                (activePag.current + 1) * sort
                              )
                              .map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    {activePag.current * sort + index + 1}
                                  </td>
                                  <td>{item?.requisitionNo}</td>
                                  <td>{item?.inventory?.masterItem?.partNo}</td>
                                  <td className="scrollable-description">{item?.inventory?.masterItem?.description}</td>
                                  <td>{item?.inventory?.qtyAuth}</td>
                                  <td>
                                    {item?.inventory?.qtyAuth -
                                      item?.inventory?.currentStock}
                                  </td>
                                  <td>{item?.inventory?.currentStock}</td>
                                  <td>{item?.qtyRequired}</td>
                                  <td className="text-danger fw-bold">{item?.flag}</td>
                                  {/* <td className="text-center">
                                    <button className="btn btn-primary btn-xs sharp" onClick={(e) => { handleModel(e, item) }}>
                                      <i className="fa fa-pencil"></i>
                                    </button>
                                   
                                  </td> */}
                                  <td><button
                            className="btn btn-success btn-xs sharp"
                            onClick={() => handleApproval(item, "approved")}
                          >
                          <i class="fa fa-thumbs-up" aria-hidden="true"></i>

                          </button>
                          <button
                            className="btn btn-danger btn-xs sharp ms-2"
                            onClick={() => handleApproval(item, "rejected")}
                          >
                            <i class="fa fa-thumbs-down" aria-hidden="true"></i>

                          </button>
                          </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center">
                                No Active items Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          Showing {activePag.current * sort + 1} to{" "}
                          {Math.min(
                            data.length,
                            (activePag.current + 1) * sort
                          )}{" "}
                          of {data.length} entries
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className="paginate_button previous"
                            to="#"
                            onClick={() =>
                              activePag.current > 0 &&
                              onClick(activePag.current - 1)
                            }
                          >
                            <i
                              className="fa fa-angle-double-left"
                              aria-hidden="true"
                            ></i>
                          </Link>
                          <span>
                            {Array.from({ length: pagination }, (_, i) => (
                              <Link
                                key={i}
                                to="#"
                                className={`paginate_button ${activePag.current === i ? "current" : ""
                                  }`}
                                onClick={() => onClick(i)}
                              >
                                {i + 1}
                              </Link>
                            ))}
                          </span>
                          <Link
                            className="paginate_button next"
                            to="#"
                            onClick={() =>
                              activePag.current < pagination - 1 &&
                              onClick(activePag.current + 1)
                            }
                          >
                            <i
                              className="fa fa-angle-double-right"
                              aria-hidden="true"
                            ></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
         )}
      </div>
    </>
  );
};

export default DiseleSuperAdminApproval ;
